import { createApiSlice } from "@common";
import {
    CRUD_PERSONAL_MARITAL_STATUS
} from "@routes";

// Define the API config array
const apiConfig = [
    {
        name: "addMyInfoBenifitsDetails",
        method: "post",
        url: CRUD_PERSONAL_MARITAL_STATUS,
        stateKey: "message",
    },
    {
        name: "getMyInfoBenifitsDetails",
        method: "get",
        url: CRUD_PERSONAL_MARITAL_STATUS,
        stateKey: "data",
    },
    {
        name: "updateMyInfoBenifitsDetails",
        method: "put",
        url: CRUD_PERSONAL_MARITAL_STATUS,
        stateKey: "message",
    },
    {
        name: "deleteMyInfoBenifitsDetails",
        method: "delete",
        url: CRUD_PERSONAL_MARITAL_STATUS,
        stateKey: "message",
    },
];

// Define custom reducers and their initial state
const customReducers = {
    initialState: {
        data: [],
        additionalData: [],
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
    },
    extraReducers: {
        // Example of custom extra reducer
        someCustomAction: (state, action) => {
            // Custom reducer logic
        },
    },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
    "MyInfoBenifitsDetails",
    apiConfig,
    customReducers,
);
const MyInfoBenifitsDetailsSlice = slice;
// Export the slice's reducer
export default MyInfoBenifitsDetailsSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
    addMyInfoBenifitsDetails,
    getMyInfoBenifitsDetails,
    updateMyInfoBenifitsDetails,
    deleteMyInfoBenifitsDetails
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
    actions;
